"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

//@flow
function parse(object) {
  var split = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.';
  var objectTree = {};

  for (var key in object) {
    var keys = key.split(split);

    if (keys.length === 1) {
      objectTree[key] = object[key];
      continue;
    }

    objectTree[keys[0]] = objectTree[keys[0]] || {};
    var _temp = objectTree[keys[0]];

    for (var i = 1; i < keys.length; i++) {
      _temp[keys[i]] = i === keys.length - 1 ? _temp[keys[i]] = object[key] : _temp[keys[i]] || {};
      _temp = _temp[keys[i]];
    }
  }

  return objectTree;
}

var _default = parse;
exports.default = _default;